import Vue from 'vue'

const menu="dinningHall/mealrate/";

export default {

    pagination(dtr,token){return Vue.prototype.$http.post(menu+"pagination",dtr);},
    save(obj,usr){
        return Vue.prototype.$http.post(menu+"save",obj,{    params:{usr:usr}});
    },
    approvalList(dtr){
        return Vue.prototype.$http.post(menu+"approvalList", dtr);
    },
    approve(obj, usrID){
        return Vue.prototype.$http.post(menu+"approve", obj, { params: { usr: usrID, usrID: usrID } });
    }
} 